import { render, staticRenderFns } from "./Terminal.vue?vue&type=template&id=4893efdb&scoped=true&"
import script from "./Terminal.vue?vue&type=script&setup=true&lang=js&"
export * from "./Terminal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893efdb",
  null
  
)

export default component.exports